import React from 'react';
import { useLanguage } from '../components/LanguageContext';
import '../styles/About.css';

const About: React.FC = () => {
  // Usa el hook useLanguage para obtener el estado actual del idioma
  const { language } = useLanguage();

  return (
    <section className="hero" id="about">
      <img src="/XD.jpg" alt="XD" loading="lazy" className="XD-icon" />
      <div className="bio animate__animated animate__shakeX">
        {/* Utiliza el idioma actual para mostrar el título correctamente */}
        <h2 className="bio-titulo">{language === 'es' ? 'Sobre Mí' : 'About Me'}</h2>
        <p className="bio-texto">
          {/* Utiliza el idioma actual para mostrar el contenido correctamente */}
          {language === 'es'
            ? "¡Hola! Soy Angelo, un apasionado Ingeniero de software con una sólida experiencia en desarrollo web full-stack. Disfruto creando sitios web unicos y agregando funcionalidades utilizando las últimas tecnologías."
            : "Hello! I'm Angelo, a passionate software engineer with a strong background in full-stack web development. I enjoy creating unique websites and adding functionalities using the latest technologies."}
        </p>
      </div>
    </section>
  );
};

export default About;



